import { jsx as i, jsxs as m } from "react/jsx-runtime";
import { clsx as v } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useRef as g } from "react";
import { useActiveNavigationPath as C } from "../../utils/use-active-navgation-path.js";
import { useNavigationKeyboard as w } from "../../utils/use-navigation-keyboard.js";
import { RocheUIIcon as _ } from "../icon/roche-icon.js";
import { isCurrentPage as s } from "../mobile-navigation/roche-mobile-navigation-helpers.js";
import n from "./roche-main-navigation-block.module.scss.js";
const U = ({
  root: f,
  currentPage: c,
  updateFlyoutPosition: l
}) => {
  const u = g([]), [o, k] = C(f, c), { handleKeyDown: h } = w(u), x = (e, t) => {
    var r;
    if (l == null || l(), ((r = o[t]) == null ? void 0 : r.url) === e.url) {
      k(o.slice(0, t));
      return;
    }
    const a = o.slice(0, t);
    a[t] = e, k(a), setTimeout(() => N(t), 0);
  }, N = (e) => {
    var t, a;
    (a = (t = u.current[e]) == null ? void 0 : t.querySelector("a, button")) == null || a.focus();
  };
  return /* @__PURE__ */ i("div", { className: n["submenu-columns"], role: "group", "aria-label": f.text, children: o.map((e, t) => {
    var a;
    return e.nestedLinks ? /* @__PURE__ */ m(
      "ul",
      {
        id: `submenu-${e.url}`,
        className: n["nav-block"],
        ref: (r) => {
          u.current[t] = r;
        },
        onKeyDown: (r) => h(r, t),
        children: [
          /* @__PURE__ */ i("li", { children: /* @__PURE__ */ m(
            "a",
            {
              href: e.url,
              className: v(
                n["nav-block__title"],
                s(e.url, c) && n["nav-block__title--active"]
              ),
              "aria-current": s(e.url, c) ? "page" : void 0,
              onClick: e.onClick,
              children: [
                e.text,
                /* @__PURE__ */ i(_, { icon: "arrow-right", height: "24px", decorative: !0 })
              ]
            }
          ) }),
          (a = e.nestedLinks) == null ? void 0 : a.map((r) => {
            var b, p;
            return /* @__PURE__ */ i("li", { children: r.nestedLinks ? /* @__PURE__ */ m(
              "button",
              {
                type: "button",
                className: v(
                  n["nav-block__item"],
                  ((b = o[t + 1]) == null ? void 0 : b.url) === r.url && n["nav-block__item--open"]
                ),
                onClick: () => x(r, t + 1),
                "aria-expanded": ((p = o[t + 1]) == null ? void 0 : p.url) === r.url,
                "aria-controls": r.url ? `submenu-${r.url}` : void 0,
                children: [
                  r.text,
                  /* @__PURE__ */ i(_, { icon: "chevron-right", height: "24px", decorative: !0 })
                ]
              }
            ) : /* @__PURE__ */ i(
              "a",
              {
                href: r.url,
                "aria-current": s(r.url, c) ? "page" : void 0,
                className: v(
                  n["nav-block__item"],
                  n["nav-block__item--link"],
                  s(r.url, c) && n["nav-block__item--active"]
                ),
                onClick: e.onClick,
                children: r.text
              }
            ) }, r.url);
          })
        ]
      },
      e.url || t
    ) : null;
  }) });
};
export {
  U as RocheUIMainNavigationBlock
};
